import React from 'react'

export interface Service {
  title: string
  description: string
  image: string
}

interface HeroSectionProps {
  className?: string
}

const companyLetters = ['A', 'B', 'C', 'D']

const HeroSection = React.memo(function HeroSection({ className }: HeroSectionProps) {
  return (
    <section className={`relative z-10 pt-32 pb-0 md:pt-48 container mx-auto px-6 text-center ${className}`}>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs font-medium text-indigo-400 mb-4 animate-in fade-in slide-in-from-bottom-4 duration-1000">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
          </span>
          The Future of Digital Enterprise
        </div>

        <h1 className="text-5xl md:text-7xl font-bold tracking-tight leading-tight animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-100">
          Building the <br />
          <span className="text-transparent bg-clip-text bg-linear-to-r from-indigo-400 via-blue-500 to-indigo-400 animate-gradient-x">
            Next Generation
          </span>
          <br /> of Logic
        </h1>

        <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-200">
          Our promise to you is quality. We ensure you can transform your business with our scalable, secure, and intelligent software solutions.
        </p>

        <div className="pt-12 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-300">
          <div className="text-center space-y-2 mb-8">
            <h3 className="text-lg font-semibold text-white">Trusted by these companies</h3>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 justify-items-center items-center opacity-70">
            {companyLetters.map((letter) => (
              <div key={letter} className="flex items-center">
                <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 shadow-lg">
                  <img
                    src={`/company-logos/logo-${letter.toLowerCase()}.png`}
                    alt={`Company ${letter}`}
                    className="h-16 w-auto"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
})

export default HeroSection
